import React from "react";
import { Switch, Route } from "react-router-dom";
import AniversarioViews from "views/aniversario-views";

export const AniversarioLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={AniversarioViews} />
			</Switch>
		</div>
	);
};

export default AniversarioLayout;
